var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw:bg-white"},[_c('div',{staticClass:"cta-container"},[_c('SignUpCtaSection',{attrs:{"title":"Get a Full Vulnerability Report"}})],1),_c('div',[_c('VulnerabilityList')],1),_c('MainMarketApps')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }